import { isFunction } from 'lodash-es';
import { IS_LOCAL_DEV, IS_NOT_PREVIEW_OR_PROD } from './constants';

/** Only throw if env is local */
export const throwIfLocalDev = (
  condition: boolean,
  message: string | Error,
): void => {
  if (IS_LOCAL_DEV && condition) {
    if (message instanceof Error) {
      throw message;
    }
    throw new Error(message);
  }
};

/** Throw if env is local, cypress, internal dev, or internal test */
export const throwIfInternalTestOrBelow = (
  conditionOrCallback: boolean | (() => boolean),
  message: string | Error,
): void => {
  if (IS_NOT_PREVIEW_OR_PROD) {
    // Use lodash-es isFunction to check if first argument is a function
    const condition = isFunction(conditionOrCallback)
      ? conditionOrCallback()
      : conditionOrCallback;

    if (condition) {
      if (message instanceof Error) {
        throw message;
      }
      throw new Error(message);
    }
  }
};
